function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import Cookie from './lib/cookies';
import { SEARCH_PARAMS_COOKIE_KEY, QUERY_SEARCH_PARAMS_WHITELIST } from './constants';
export default function getSearchMap() {
  return parseSearchString(getSearchStringFromURL());
}
/**
 * Parses a string of query params separated by "&" and returns a whitelisted object of key/values
 * @param {string} query string (can be fetched by #getSearchStringFromURL)
 * @return {Object}
 */

function parseSearchString() {
  var queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var queryHash = {};
  var pairs = queryString.split('&');
  pairs.forEach(function (pair) {
    var _pair$split = pair.split('='),
        _pair$split2 = _slicedToArray(_pair$split, 2),
        encodedKey = _pair$split2[0],
        encodedValue = _pair$split2[1];

    var key = decodeURIComponent(encodedKey);
    var value = decodeURIComponent(encodedValue);

    if (value && QUERY_SEARCH_PARAMS_WHITELIST.includes(key)) {
      queryHash[key] = value;
    }
  });
  return queryHash;
}
/**
 * Returns the current search value from the URL and strips out the "?"
 * @return {String}
 */


function getSearchStringFromURL() {
  if (!window) return;
  if (!window.location.search) return; // remove ? from string

  return window.location.search.substr(1);
}
/**
 * Merges an object with the current value of the search params cookie
 * @param {Object} A map of search params, typically from the URL query params
 * @return {Object} Merged map of argument with current values, new values take priority
 */


export function mergeSearchParamsWithCurrentCookie(paramsMap) {
  var cookie = JSON.parse(decodeURIComponent(Cookie.getItem(SEARCH_PARAMS_COOKIE_KEY))); // short curcuit if the current cookie value does not exist

  if (!cookie) return paramsMap; // created a merged map that defaults to current cookie values

  var mergedMap = Object.assign({}, cookie);
  Object.keys(paramsMap).forEach(function (key) {
    var value = paramsMap[key]; // only overide of new value is truthy,
    // dont want to override with undefineds or ''s.

    if (value) {
      mergedMap[key] = value;
    }
  });
  return mergedMap;
}